var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"onglets"},_vm._l((_vm.onglets),function(onglet,index){return _c('div',{key:'onglet_' + onglet.code,class:['onglet', { active: _vm.active === onglet.code }],on:{"click":function($event){return _vm.selectOnglet(onglet.code)}}},[_vm._v(" "+_vm._s(onglet.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }